<template>
  <div class="mt-8">
    <px-view-module-header module-name="Marketplace" :breadcrumbs="breadcrumbs"/>
    <px-view-header-title class="mt-8" title="Pendências"/>
    <div class="mt-5">
      <v-row>
        <v-col cols="12" sm="4">
          <px-card-vendas-pendentes :vendas="vendas"/>
        </v-col>
        <v-col cols="12" sm="4">
          <px-card-perguntas-pendentes :perguntas="perguntas"/>
        </v-col>
        <v-col cols="12" sm="4">
          <px-card-alertas-pendentes :alertas="alertas"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <px-pendencias-listagem-vendas @loaded="onLoadVendas"/>
        </v-col>
        <v-col cols="6">
          <px-pendencias-listagem-perguntas @loaded="onLoadPerguntas"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <px-pendencias-listagem-alertas @loaded="onLoadAlertas"/>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import CardVendasPendentes from './CardVendasPendentes.vue';
import CardPerguntasPendentes from './CardPerguntasPendentes.vue';
import CardAlertasPendentes from './CardAlertasPendentes.vue';
import PendenciasListagemVendas from './vendas/PendenciasListagemVendas.vue';
import PendenciasListagemPerguntas from './perguntas/PendenciasListagemPerguntas.vue';
import PendenciasListagemAlertas from './alertas/PendenciasListagemAlertas.vue';

export default {
  data() {
    return {
      vendas: null,
      perguntas: null,
      alertas: null,
      breadcrumbs: [
        { text: 'Marketplace' },
        { text: 'Pendências' },
      ],
    };
  },
  methods: {
    onLoadVendas(vendas) {
      this.vendas = vendas;
    },
    onLoadPerguntas(perguntas) {
      this.perguntas = perguntas;
    },
    onLoadAlertas(alertas) {
      this.alertas = alertas;
    },
  },
  components: {
    pxCardVendasPendentes: CardVendasPendentes,
    pxCardPerguntasPendentes: CardPerguntasPendentes,
    pxCardAlertasPendentes: CardAlertasPendentes,
    pxPendenciasListagemVendas: PendenciasListagemVendas,
    pxPendenciasListagemPerguntas: PendenciasListagemPerguntas,
    pxPendenciasListagemAlertas: PendenciasListagemAlertas,
  },
};
</script>
